module.exports = __webpack_public_path__ + "static/mobile-phone-spin-f699ea0bc2e783a3d48157436fa2c4d5.mp4";